import { Organization }  from '@app/modules/organization/models/organization.model';
import {
	OrganizationDTO,
	OrganizationUpdateBodyDTO
}                        from '@openApiGenerated/admin-api';
import {
	NaturalPersonDTO,
	OrganizationBodyDTO
}                        from '@openApiGenerated/management-api';
import { NaturalPerson } from '@shared/models/natural-person.model';
import { ObjectUtils }   from '@utils/helpers';

export {
	isNaturalPerson,
	isNaturalPersonDto
};

/**
 * Checks if organization's (EMO) legal form is 'Natural Person' by presence of
 * property `naturalPerson` with at least one of its sub-properties not being
 * `undefined` or `null`.
 */
function isNaturalPerson( organization: Organization ): boolean {
	return organization && !isNaturalPersonEmpty( organization.naturalPerson );
}

/**
 * Checks if organization's (DTO) legal form is 'Natural Person' by presence of
 * property `naturalPerson` with at least one of its sub-properties not being
 * `undefined` or `null`.
 */
function isNaturalPersonDto( organizationDto: OrganizationDTO | OrganizationBodyDTO | OrganizationUpdateBodyDTO ): boolean {
	return organizationDto && !isNaturalPersonEmpty( organizationDto.naturalPerson );
}

/**
 * NaturalPerson is either nullish or is a non-nullish object with all of its
 * properties being empty (`undefined` or `null`).
 */
function isNaturalPersonEmpty( naturalPerson: NaturalPerson | NaturalPersonDTO ): boolean {
	return ObjectUtils.isNullish( naturalPerson )
		|| ( ObjectUtils.isObject( naturalPerson )
					&& Object.values( naturalPerson ).every( ( value: any ) => {
						return ObjectUtils.isNullish( value );
				 	} )
		);
}
